import * as Types from "../../../apollo/graphql.generated";

import { gql } from "@apollo/client";
import { CollectionFieldsFragmentDoc } from "../../tokens/queries/collections.graphql.generated";
import { ContractFieldsFragmentDoc } from "./contracts.graphql.generated";
import * as Apollo from "@apollo/client";
const defaultOptions = {};
export type DraftFieldsFragment = {
  __typename: "CollectionDraft";
  id: string;
  accountId: string;
  createdAt: string;
  updatedAt: string;
  collectionType: Types._CollectionType;
  furthestStep: Types.DraftProgress;
  contractId: string | null;
  gateId: string | null;
  metadata: {
    __typename: "CollectionMetadata";
    mediaUrl: string | null;
    mediaFiles: Array<string> | null;
    coverMediaUrl: string | null;
    reveal: boolean | null;
    mediaTypeStr: string | null;
    seriesS3Unzipped: boolean | null;
    generateNameTrait: boolean | null;
    traits: Array<{
      __typename: "TraitAttribute";
      traitName: string;
      traitValue: string;
    }> | null;
    seriesDetails: {
      __typename: "SeriesDetailsDraft";
      coverImage: Array<number> | null;
      mintPreviewImages: Array<number> | null;
      mintPreviewImageUrls: Array<string> | null;
      showAllMetadata: boolean | null;
    } | null;
  } | null;
  collectionDraft: {
    __typename: "CollectionDetailsDraft";
    name: string | null;
    description: string | null;
    size: number | null;
    categories: Array<string> | null;
    tags: Array<{ __typename: "TagDraft"; name: string; slug: string }> | null;
    seriesDetails: {
      __typename: "SeriesDetailsDraft";
      coverImage: Array<number> | null;
      mintPreviewImages: Array<number> | null;
      mintPreviewImageUrls: Array<string> | null;
      showAllMetadata: boolean | null;
    } | null;
    generativeDetails: {
      __typename: "GenerativeDetailsDraft";
      curateOutput: boolean | null;
      isGPURendering: boolean | null;
      allowedHashes: Array<string> | null;
      editionType: Types.GenerativeEditionType | null;
      captureSettings: {
        __typename: "GenerativeCaptureSettings";
        trigger: Types.CapturePreviewTriggerType;
        delay: number | null;
        selector: string | null;
        selectorType: string | null;
        viewPort: {
          __typename: "GenerativeCaptureViewPortSettings";
          width: number;
          height: number;
        } | null;
      } | null;
    } | null;
  } | null;
  contractDraft: {
    __typename: "ContractDraft";
    name: string | null;
    symbol: string | null;
    chainId: number | null;
    usingOpenseaBlocklist: boolean | null;
    collectionLogoImage: string | null;
  } | null;
  distributionDraft: {
    __typename: "DistributionDraft";
    type: Types.TokenDistributionType;
    price: string | null;
    currency: string | null;
    saleDateFrom: string | null;
    saleDateTo: string | null;
    priceType: Types.PriceType | null;
    scheduledPrices: Array<string> | null;
    isDirectMint: boolean | null;
    minBid: string | null;
    rebateWinningBids: boolean | null;
    sponsoredMintsEnabled: boolean | null;
    priceDropInterval: Array<{
      __typename: "PriceDropTimePeriod";
      unit: Types.TimeUnit;
      value: number;
    }> | null;
  } | null;
  moduleSettings: {
    __typename: "ModuleSettingsDraft";
    maxPerTxn: number | null;
    limitedMints: {
      __typename: "LimitedMintsSettings";
      limitPerWallet: number;
    } | null;
    nonTransferable: {
      __typename: "NonTransferableSettings";
      active: boolean;
    } | null;
    royalty: {
      __typename: "RoyaltySettings";
      royaltyAmount: number | null;
      payoutEnsName: string | null;
      payoutEoa: string | null;
    } | null;
    customPaymentRecipient: {
      __typename: "CustomPaymentRecipientSettings";
      ensName: string | null;
      eoa: string | null;
    } | null;
  };
};

export type CreateCollectionDraftMutationVariables = Types.Exact<{
  createCollectionDraftData: Types.CreateCollectionDraftInput;
}>;

export type CreateCollectionDraftMutation = {
  createCollectionDraft: {
    __typename: "CreateCollectionDraftOutput";
    seriesUploadUrl: string | null;
    draft: {
      __typename: "CollectionDraft";
      id: string;
      accountId: string;
      createdAt: string;
      updatedAt: string;
      collectionType: Types._CollectionType;
      furthestStep: Types.DraftProgress;
      contractId: string | null;
      gateId: string | null;
      metadata: {
        __typename: "CollectionMetadata";
        mediaUrl: string | null;
        mediaFiles: Array<string> | null;
        coverMediaUrl: string | null;
        reveal: boolean | null;
        mediaTypeStr: string | null;
        seriesS3Unzipped: boolean | null;
        generateNameTrait: boolean | null;
        traits: Array<{
          __typename: "TraitAttribute";
          traitName: string;
          traitValue: string;
        }> | null;
        seriesDetails: {
          __typename: "SeriesDetailsDraft";
          coverImage: Array<number> | null;
          mintPreviewImages: Array<number> | null;
          mintPreviewImageUrls: Array<string> | null;
          showAllMetadata: boolean | null;
        } | null;
      } | null;
      collectionDraft: {
        __typename: "CollectionDetailsDraft";
        name: string | null;
        description: string | null;
        size: number | null;
        categories: Array<string> | null;
        tags: Array<{
          __typename: "TagDraft";
          name: string;
          slug: string;
        }> | null;
        seriesDetails: {
          __typename: "SeriesDetailsDraft";
          coverImage: Array<number> | null;
          mintPreviewImages: Array<number> | null;
          mintPreviewImageUrls: Array<string> | null;
          showAllMetadata: boolean | null;
        } | null;
        generativeDetails: {
          __typename: "GenerativeDetailsDraft";
          curateOutput: boolean | null;
          isGPURendering: boolean | null;
          allowedHashes: Array<string> | null;
          editionType: Types.GenerativeEditionType | null;
          captureSettings: {
            __typename: "GenerativeCaptureSettings";
            trigger: Types.CapturePreviewTriggerType;
            delay: number | null;
            selector: string | null;
            selectorType: string | null;
            viewPort: {
              __typename: "GenerativeCaptureViewPortSettings";
              width: number;
              height: number;
            } | null;
          } | null;
        } | null;
      } | null;
      contractDraft: {
        __typename: "ContractDraft";
        name: string | null;
        symbol: string | null;
        chainId: number | null;
        usingOpenseaBlocklist: boolean | null;
        collectionLogoImage: string | null;
      } | null;
      distributionDraft: {
        __typename: "DistributionDraft";
        type: Types.TokenDistributionType;
        price: string | null;
        currency: string | null;
        saleDateFrom: string | null;
        saleDateTo: string | null;
        priceType: Types.PriceType | null;
        scheduledPrices: Array<string> | null;
        isDirectMint: boolean | null;
        minBid: string | null;
        rebateWinningBids: boolean | null;
        sponsoredMintsEnabled: boolean | null;
        priceDropInterval: Array<{
          __typename: "PriceDropTimePeriod";
          unit: Types.TimeUnit;
          value: number;
        }> | null;
      } | null;
      moduleSettings: {
        __typename: "ModuleSettingsDraft";
        maxPerTxn: number | null;
        limitedMints: {
          __typename: "LimitedMintsSettings";
          limitPerWallet: number;
        } | null;
        nonTransferable: {
          __typename: "NonTransferableSettings";
          active: boolean;
        } | null;
        royalty: {
          __typename: "RoyaltySettings";
          royaltyAmount: number | null;
          payoutEnsName: string | null;
          payoutEoa: string | null;
        } | null;
        customPaymentRecipient: {
          __typename: "CustomPaymentRecipientSettings";
          ensName: string | null;
          eoa: string | null;
        } | null;
      };
    };
  };
};

export type GetUploadUrlForSeriesMutationVariables = Types.Exact<{
  data: Types.SeriesZipUploadInput;
}>;

export type GetUploadUrlForSeriesMutation = {
  getUploadUrlForSeries: {
    __typename: "SeriesUploadOutput";
    id: string;
    metadata: {
      __typename: "SeriesZipUploadMetadata";
      type: Types.SupportedZipMediaType;
      mime: string;
      url: string;
      publicUrl: string;
    };
  };
};

export type UpdateCollectionDraftMutationVariables = Types.Exact<{
  draftId: Types.Scalars["String"];
  updateCollectionDraftData: Types.UpdateCollectionDraftInput;
}>;

export type UpdateCollectionDraftMutation = {
  updateCollectionDraft: {
    __typename: "CollectionDraft";
    id: string;
    accountId: string;
    createdAt: string;
    updatedAt: string;
    collectionType: Types._CollectionType;
    furthestStep: Types.DraftProgress;
    contractId: string | null;
    gateId: string | null;
    metadata: {
      __typename: "CollectionMetadata";
      mediaUrl: string | null;
      mediaFiles: Array<string> | null;
      coverMediaUrl: string | null;
      reveal: boolean | null;
      mediaTypeStr: string | null;
      seriesS3Unzipped: boolean | null;
      generateNameTrait: boolean | null;
      traits: Array<{
        __typename: "TraitAttribute";
        traitName: string;
        traitValue: string;
      }> | null;
      seriesDetails: {
        __typename: "SeriesDetailsDraft";
        coverImage: Array<number> | null;
        mintPreviewImages: Array<number> | null;
        mintPreviewImageUrls: Array<string> | null;
        showAllMetadata: boolean | null;
      } | null;
    } | null;
    collectionDraft: {
      __typename: "CollectionDetailsDraft";
      name: string | null;
      description: string | null;
      size: number | null;
      categories: Array<string> | null;
      tags: Array<{
        __typename: "TagDraft";
        name: string;
        slug: string;
      }> | null;
      seriesDetails: {
        __typename: "SeriesDetailsDraft";
        coverImage: Array<number> | null;
        mintPreviewImages: Array<number> | null;
        mintPreviewImageUrls: Array<string> | null;
        showAllMetadata: boolean | null;
      } | null;
      generativeDetails: {
        __typename: "GenerativeDetailsDraft";
        curateOutput: boolean | null;
        isGPURendering: boolean | null;
        allowedHashes: Array<string> | null;
        editionType: Types.GenerativeEditionType | null;
        captureSettings: {
          __typename: "GenerativeCaptureSettings";
          trigger: Types.CapturePreviewTriggerType;
          delay: number | null;
          selector: string | null;
          selectorType: string | null;
          viewPort: {
            __typename: "GenerativeCaptureViewPortSettings";
            width: number;
            height: number;
          } | null;
        } | null;
      } | null;
    } | null;
    contractDraft: {
      __typename: "ContractDraft";
      name: string | null;
      symbol: string | null;
      chainId: number | null;
      usingOpenseaBlocklist: boolean | null;
      collectionLogoImage: string | null;
    } | null;
    distributionDraft: {
      __typename: "DistributionDraft";
      type: Types.TokenDistributionType;
      price: string | null;
      currency: string | null;
      saleDateFrom: string | null;
      saleDateTo: string | null;
      priceType: Types.PriceType | null;
      scheduledPrices: Array<string> | null;
      isDirectMint: boolean | null;
      minBid: string | null;
      rebateWinningBids: boolean | null;
      sponsoredMintsEnabled: boolean | null;
      priceDropInterval: Array<{
        __typename: "PriceDropTimePeriod";
        unit: Types.TimeUnit;
        value: number;
      }> | null;
    } | null;
    moduleSettings: {
      __typename: "ModuleSettingsDraft";
      maxPerTxn: number | null;
      limitedMints: {
        __typename: "LimitedMintsSettings";
        limitPerWallet: number;
      } | null;
      nonTransferable: {
        __typename: "NonTransferableSettings";
        active: boolean;
      } | null;
      royalty: {
        __typename: "RoyaltySettings";
        royaltyAmount: number | null;
        payoutEnsName: string | null;
        payoutEoa: string | null;
      } | null;
      customPaymentRecipient: {
        __typename: "CustomPaymentRecipientSettings";
        ensName: string | null;
        eoa: string | null;
      } | null;
    };
  };
};

export type RefreshCollectionDraftMutationVariables = Types.Exact<{
  draftId: Types.Scalars["String"];
}>;

export type RefreshCollectionDraftMutation = {
  refreshCollectionDraft: {
    __typename: "CollectionDraft";
    id: string;
    accountId: string;
    createdAt: string;
    updatedAt: string;
    collectionType: Types._CollectionType;
    furthestStep: Types.DraftProgress;
    contractId: string | null;
    gateId: string | null;
    metadata: {
      __typename: "CollectionMetadata";
      mediaUrl: string | null;
      mediaFiles: Array<string> | null;
      coverMediaUrl: string | null;
      reveal: boolean | null;
      mediaTypeStr: string | null;
      seriesS3Unzipped: boolean | null;
      generateNameTrait: boolean | null;
      traits: Array<{
        __typename: "TraitAttribute";
        traitName: string;
        traitValue: string;
      }> | null;
      seriesDetails: {
        __typename: "SeriesDetailsDraft";
        coverImage: Array<number> | null;
        mintPreviewImages: Array<number> | null;
        mintPreviewImageUrls: Array<string> | null;
        showAllMetadata: boolean | null;
      } | null;
    } | null;
    collectionDraft: {
      __typename: "CollectionDetailsDraft";
      name: string | null;
      description: string | null;
      size: number | null;
      categories: Array<string> | null;
      tags: Array<{
        __typename: "TagDraft";
        name: string;
        slug: string;
      }> | null;
      seriesDetails: {
        __typename: "SeriesDetailsDraft";
        coverImage: Array<number> | null;
        mintPreviewImages: Array<number> | null;
        mintPreviewImageUrls: Array<string> | null;
        showAllMetadata: boolean | null;
      } | null;
      generativeDetails: {
        __typename: "GenerativeDetailsDraft";
        curateOutput: boolean | null;
        isGPURendering: boolean | null;
        allowedHashes: Array<string> | null;
        editionType: Types.GenerativeEditionType | null;
        captureSettings: {
          __typename: "GenerativeCaptureSettings";
          trigger: Types.CapturePreviewTriggerType;
          delay: number | null;
          selector: string | null;
          selectorType: string | null;
          viewPort: {
            __typename: "GenerativeCaptureViewPortSettings";
            width: number;
            height: number;
          } | null;
        } | null;
      } | null;
    } | null;
    contractDraft: {
      __typename: "ContractDraft";
      name: string | null;
      symbol: string | null;
      chainId: number | null;
      usingOpenseaBlocklist: boolean | null;
      collectionLogoImage: string | null;
    } | null;
    distributionDraft: {
      __typename: "DistributionDraft";
      type: Types.TokenDistributionType;
      price: string | null;
      currency: string | null;
      saleDateFrom: string | null;
      saleDateTo: string | null;
      priceType: Types.PriceType | null;
      scheduledPrices: Array<string> | null;
      isDirectMint: boolean | null;
      minBid: string | null;
      rebateWinningBids: boolean | null;
      sponsoredMintsEnabled: boolean | null;
      priceDropInterval: Array<{
        __typename: "PriceDropTimePeriod";
        unit: Types.TimeUnit;
        value: number;
      }> | null;
    } | null;
    moduleSettings: {
      __typename: "ModuleSettingsDraft";
      maxPerTxn: number | null;
      limitedMints: {
        __typename: "LimitedMintsSettings";
        limitPerWallet: number;
      } | null;
      nonTransferable: {
        __typename: "NonTransferableSettings";
        active: boolean;
      } | null;
      royalty: {
        __typename: "RoyaltySettings";
        royaltyAmount: number | null;
        payoutEnsName: string | null;
        payoutEoa: string | null;
      } | null;
      customPaymentRecipient: {
        __typename: "CustomPaymentRecipientSettings";
        ensName: string | null;
        eoa: string | null;
      } | null;
    };
  };
};

export type IsSeriesUnzipDoneQueryVariables = Types.Exact<{
  seriesZipFolderName: Types.Scalars["String"];
}>;

export type IsSeriesUnzipDoneQuery = {
  isSeriesUnzipDone: {
    __typename: "IsSeriesUnzipped";
    finishedUnzipping: boolean;
  };
};

export type DeployDraftMutationVariables = Types.Exact<{
  draftId: Types.Scalars["String"];
}>;

export type DeployDraftMutation = {
  deployCollection: {
    __typename: "CollectionDraft";
    id: string;
    accountId: string;
    createdAt: string;
    updatedAt: string;
    collectionType: Types._CollectionType;
    furthestStep: Types.DraftProgress;
    contractId: string | null;
    gateId: string | null;
    metadata: {
      __typename: "CollectionMetadata";
      mediaUrl: string | null;
      mediaFiles: Array<string> | null;
      coverMediaUrl: string | null;
      reveal: boolean | null;
      mediaTypeStr: string | null;
      seriesS3Unzipped: boolean | null;
      generateNameTrait: boolean | null;
      traits: Array<{
        __typename: "TraitAttribute";
        traitName: string;
        traitValue: string;
      }> | null;
      seriesDetails: {
        __typename: "SeriesDetailsDraft";
        coverImage: Array<number> | null;
        mintPreviewImages: Array<number> | null;
        mintPreviewImageUrls: Array<string> | null;
        showAllMetadata: boolean | null;
      } | null;
    } | null;
    collectionDraft: {
      __typename: "CollectionDetailsDraft";
      name: string | null;
      description: string | null;
      size: number | null;
      categories: Array<string> | null;
      tags: Array<{
        __typename: "TagDraft";
        name: string;
        slug: string;
      }> | null;
      seriesDetails: {
        __typename: "SeriesDetailsDraft";
        coverImage: Array<number> | null;
        mintPreviewImages: Array<number> | null;
        mintPreviewImageUrls: Array<string> | null;
        showAllMetadata: boolean | null;
      } | null;
      generativeDetails: {
        __typename: "GenerativeDetailsDraft";
        curateOutput: boolean | null;
        isGPURendering: boolean | null;
        allowedHashes: Array<string> | null;
        editionType: Types.GenerativeEditionType | null;
        captureSettings: {
          __typename: "GenerativeCaptureSettings";
          trigger: Types.CapturePreviewTriggerType;
          delay: number | null;
          selector: string | null;
          selectorType: string | null;
          viewPort: {
            __typename: "GenerativeCaptureViewPortSettings";
            width: number;
            height: number;
          } | null;
        } | null;
      } | null;
    } | null;
    contractDraft: {
      __typename: "ContractDraft";
      name: string | null;
      symbol: string | null;
      chainId: number | null;
      usingOpenseaBlocklist: boolean | null;
      collectionLogoImage: string | null;
    } | null;
    distributionDraft: {
      __typename: "DistributionDraft";
      type: Types.TokenDistributionType;
      price: string | null;
      currency: string | null;
      saleDateFrom: string | null;
      saleDateTo: string | null;
      priceType: Types.PriceType | null;
      scheduledPrices: Array<string> | null;
      isDirectMint: boolean | null;
      minBid: string | null;
      rebateWinningBids: boolean | null;
      sponsoredMintsEnabled: boolean | null;
      priceDropInterval: Array<{
        __typename: "PriceDropTimePeriod";
        unit: Types.TimeUnit;
        value: number;
      }> | null;
    } | null;
    moduleSettings: {
      __typename: "ModuleSettingsDraft";
      maxPerTxn: number | null;
      limitedMints: {
        __typename: "LimitedMintsSettings";
        limitPerWallet: number;
      } | null;
      nonTransferable: {
        __typename: "NonTransferableSettings";
        active: boolean;
      } | null;
      royalty: {
        __typename: "RoyaltySettings";
        royaltyAmount: number | null;
        payoutEnsName: string | null;
        payoutEoa: string | null;
      } | null;
      customPaymentRecipient: {
        __typename: "CustomPaymentRecipientSettings";
        ensName: string | null;
        eoa: string | null;
      } | null;
    };
  };
};

export type CollectionDraftQueryVariables = Types.Exact<{
  collectionDraftId: Types.Scalars["String"];
  first: Types.Maybe<Types.Scalars["Float"]>;
}>;

export type CollectionDraftQuery = {
  collectionDraft: {
    __typename: "CollectionDraft";
    id: string;
    accountId: string;
    createdAt: string;
    updatedAt: string;
    collectionType: Types._CollectionType;
    furthestStep: Types.DraftProgress;
    contractId: string | null;
    gateId: string | null;
    seriesTokens: {
      __typename: "SeriesTokensPaginated";
      edges: Array<{
        __typename: "SeriesToken";
        imageUrl: string | null;
        tokenId: string | null;
        name: string;
        attributes: Array<{
          __typename: "SeriesTokenAttribute";
          name: string;
          value: string;
        }>;
      }>;
      pageInfo: { __typename: "CursorPaginatedInfo"; totalCount: number };
    } | null;
    metadata: {
      __typename: "CollectionMetadata";
      mediaUrl: string | null;
      mediaFiles: Array<string> | null;
      coverMediaUrl: string | null;
      reveal: boolean | null;
      mediaTypeStr: string | null;
      seriesS3Unzipped: boolean | null;
      generateNameTrait: boolean | null;
      traits: Array<{
        __typename: "TraitAttribute";
        traitName: string;
        traitValue: string;
      }> | null;
      seriesDetails: {
        __typename: "SeriesDetailsDraft";
        coverImage: Array<number> | null;
        mintPreviewImages: Array<number> | null;
        mintPreviewImageUrls: Array<string> | null;
        showAllMetadata: boolean | null;
      } | null;
    } | null;
    collectionDraft: {
      __typename: "CollectionDetailsDraft";
      name: string | null;
      description: string | null;
      size: number | null;
      categories: Array<string> | null;
      tags: Array<{
        __typename: "TagDraft";
        name: string;
        slug: string;
      }> | null;
      seriesDetails: {
        __typename: "SeriesDetailsDraft";
        coverImage: Array<number> | null;
        mintPreviewImages: Array<number> | null;
        mintPreviewImageUrls: Array<string> | null;
        showAllMetadata: boolean | null;
      } | null;
      generativeDetails: {
        __typename: "GenerativeDetailsDraft";
        curateOutput: boolean | null;
        isGPURendering: boolean | null;
        allowedHashes: Array<string> | null;
        editionType: Types.GenerativeEditionType | null;
        captureSettings: {
          __typename: "GenerativeCaptureSettings";
          trigger: Types.CapturePreviewTriggerType;
          delay: number | null;
          selector: string | null;
          selectorType: string | null;
          viewPort: {
            __typename: "GenerativeCaptureViewPortSettings";
            width: number;
            height: number;
          } | null;
        } | null;
      } | null;
    } | null;
    contractDraft: {
      __typename: "ContractDraft";
      name: string | null;
      symbol: string | null;
      chainId: number | null;
      usingOpenseaBlocklist: boolean | null;
      collectionLogoImage: string | null;
    } | null;
    distributionDraft: {
      __typename: "DistributionDraft";
      type: Types.TokenDistributionType;
      price: string | null;
      currency: string | null;
      saleDateFrom: string | null;
      saleDateTo: string | null;
      priceType: Types.PriceType | null;
      scheduledPrices: Array<string> | null;
      isDirectMint: boolean | null;
      minBid: string | null;
      rebateWinningBids: boolean | null;
      sponsoredMintsEnabled: boolean | null;
      priceDropInterval: Array<{
        __typename: "PriceDropTimePeriod";
        unit: Types.TimeUnit;
        value: number;
      }> | null;
    } | null;
    moduleSettings: {
      __typename: "ModuleSettingsDraft";
      maxPerTxn: number | null;
      limitedMints: {
        __typename: "LimitedMintsSettings";
        limitPerWallet: number;
      } | null;
      nonTransferable: {
        __typename: "NonTransferableSettings";
        active: boolean;
      } | null;
      royalty: {
        __typename: "RoyaltySettings";
        royaltyAmount: number | null;
        payoutEnsName: string | null;
        payoutEoa: string | null;
      } | null;
      customPaymentRecipient: {
        __typename: "CustomPaymentRecipientSettings";
        ensName: string | null;
        eoa: string | null;
      } | null;
    };
  };
};

export type DeployCollectionParamsQueryVariables = Types.Exact<{
  draftId: Types.Scalars["String"];
}>;

export type DeployCollectionParamsQuery = {
  deployCollectionParams: {
    __typename: "DeployDraftOutput";
    collection: {
      __typename: "Collection";
      id: string;
      name: string;
      type: Types.CollectionContractType;
      collectionType: Types._CollectionType;
      chainId: number;
      contractId: string;
      status: Types.CollectionStatus;
      createdAt: string;
      baseUri: string | null;
      usingOpenseaBlocklist: boolean | null;
      seriesDetails: {
        __typename: "SeriesDetails";
        coverImage: number;
        mintPreviewImages: Array<number>;
        mintPreviewImageUrls: Array<string> | null;
        mintPreviewMediaUrls: Array<string> | null;
        logoUrl: string | null;
      } | null;
      generativeDetails: {
        __typename: "GenerativeDetails";
        logoUrl: string | null;
        generativeCodeUri: string;
        allowedHashes: Array<string> | null;
        mirroredBaseUri: string | null;
        captureSettings: {
          __typename: "GenerativeCaptureSettings";
          trigger: Types.CapturePreviewTriggerType;
          delay: number | null;
          selector: string | null;
          viewPort: {
            __typename: "GenerativeCaptureViewPortSettings";
            height: number;
            width: number;
          } | null;
        };
      } | null;
      seriesImages: {
        __typename: "SeriesImages";
        urls: Array<string>;
        coverImageUrl: string;
      } | null;
      editions: Array<{
        __typename: "EditionToken";
        name: string;
        description: string;
        image: string;
        size: number;
        onChainImage: string;
        nonTransferable: boolean | null;
        attributes: Array<{
          __typename: "TokenMetadataAttribute";
          trait_type: string;
          value: string;
        }> | null;
      }> | null;
      tokens: Array<{
        __typename: "GeneralToken";
        animation_url: string | null;
        image: string;
        name: string;
        description: string;
        id: string;
        nonTransferable: boolean | null;
        royalty: {
          __typename: "V1Royalty";
          royaltyPercentageString: string | null;
          royaltyRecipient: string | null;
        } | null;
      }> | null;
      importData: {
        __typename: "ImportData";
        description: string | null;
        media: string | null;
        standard: string | null;
        royalty: {
          __typename: "V1Royalty";
          royaltyRecipient: string | null;
          royaltyPercentageString: string | null;
        } | null;
      } | null;
      contract: { __typename: "Contract2"; address: string | null } | null;
    };
    transactionArgs: {
      __typename: "TransactionArgs";
      address: string | null;
      args: string;
      bytecode: string | null;
      chainId: number;
      method: string | null;
      value: string | null;
      gasLimit: string | null;
    };
    contract: {
      __typename: "Contract2";
      id: string;
      chainId: number;
      contractType: Types.ContractEntityType;
      name: string;
      address: string | null;
      symbol: string;
      contractUri: string | null;
      createdAt: string | null;
    };
  };
};

export const DraftFieldsFragmentDoc = gql`
  fragment DraftFields on CollectionDraft {
    id
    accountId
    createdAt
    updatedAt
    collectionType
    furthestStep
    contractId
    gateId
    metadata {
      mediaUrl
      mediaFiles
      coverMediaUrl
      reveal
      mediaTypeStr
      traits {
        traitName
        traitValue
      }
      seriesDetails {
        coverImage
        mintPreviewImages
        mintPreviewImageUrls
        showAllMetadata
      }
      seriesS3Unzipped
      generateNameTrait
    }
    collectionDraft {
      name
      description
      size
      categories
      tags {
        name
        slug
      }
      seriesDetails {
        coverImage
        mintPreviewImages
        mintPreviewImageUrls
        showAllMetadata
      }
      generativeDetails {
        curateOutput
        isGPURendering
        allowedHashes
        captureSettings {
          trigger
          delay
          viewPort {
            width
            height
          }
          selector
          selectorType
        }
        editionType
      }
    }
    contractDraft {
      name
      symbol
      chainId
      usingOpenseaBlocklist
      collectionLogoImage
    }
    distributionDraft {
      type
      price
      currency
      saleDateFrom
      saleDateTo
      priceType
      scheduledPrices
      priceDropInterval {
        unit
        value
      }
      isDirectMint
      minBid
      rebateWinningBids
      sponsoredMintsEnabled
    }
    moduleSettings {
      limitedMints {
        limitPerWallet
      }
      nonTransferable {
        active
      }
      royalty {
        royaltyAmount
        payoutEnsName
        payoutEoa
      }
      customPaymentRecipient {
        ensName
        eoa
      }
      maxPerTxn
    }
  }
`;
export const CreateCollectionDraftDocument = gql`
  mutation CreateCollectionDraft(
    $createCollectionDraftData: CreateCollectionDraftInput!
  ) {
    createCollectionDraft(data: $createCollectionDraftData) {
      draft {
        ...DraftFields
      }
      seriesUploadUrl
    }
  }
  ${DraftFieldsFragmentDoc}
`;
export type CreateCollectionDraftMutationFn = Apollo.MutationFunction<
  CreateCollectionDraftMutation,
  CreateCollectionDraftMutationVariables
>;

/**
 * __useCreateCollectionDraftMutation__
 *
 * To run a mutation, you first call `useCreateCollectionDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCollectionDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCollectionDraftMutation, { data, loading, error }] = useCreateCollectionDraftMutation({
 *   variables: {
 *      createCollectionDraftData: // value for 'createCollectionDraftData'
 *   },
 * });
 */
export function useCreateCollectionDraftMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateCollectionDraftMutation,
    CreateCollectionDraftMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateCollectionDraftMutation,
    CreateCollectionDraftMutationVariables
  >(CreateCollectionDraftDocument, options);
}
export type CreateCollectionDraftMutationHookResult = ReturnType<
  typeof useCreateCollectionDraftMutation
>;
export type CreateCollectionDraftMutationResult =
  Apollo.MutationResult<CreateCollectionDraftMutation>;
export type CreateCollectionDraftMutationOptions = Apollo.BaseMutationOptions<
  CreateCollectionDraftMutation,
  CreateCollectionDraftMutationVariables
>;
export const GetUploadUrlForSeriesDocument = gql`
  mutation GetUploadUrlForSeries($data: SeriesZipUploadInput!) {
    getUploadUrlForSeries(data: $data) {
      id
      metadata {
        type
        mime
        url
        publicUrl
      }
    }
  }
`;
export type GetUploadUrlForSeriesMutationFn = Apollo.MutationFunction<
  GetUploadUrlForSeriesMutation,
  GetUploadUrlForSeriesMutationVariables
>;

/**
 * __useGetUploadUrlForSeriesMutation__
 *
 * To run a mutation, you first call `useGetUploadUrlForSeriesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetUploadUrlForSeriesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getUploadUrlForSeriesMutation, { data, loading, error }] = useGetUploadUrlForSeriesMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetUploadUrlForSeriesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    GetUploadUrlForSeriesMutation,
    GetUploadUrlForSeriesMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    GetUploadUrlForSeriesMutation,
    GetUploadUrlForSeriesMutationVariables
  >(GetUploadUrlForSeriesDocument, options);
}
export type GetUploadUrlForSeriesMutationHookResult = ReturnType<
  typeof useGetUploadUrlForSeriesMutation
>;
export type GetUploadUrlForSeriesMutationResult =
  Apollo.MutationResult<GetUploadUrlForSeriesMutation>;
export type GetUploadUrlForSeriesMutationOptions = Apollo.BaseMutationOptions<
  GetUploadUrlForSeriesMutation,
  GetUploadUrlForSeriesMutationVariables
>;
export const UpdateCollectionDraftDocument = gql`
  mutation UpdateCollectionDraft(
    $draftId: String!
    $updateCollectionDraftData: UpdateCollectionDraftInput!
  ) {
    updateCollectionDraft(draftId: $draftId, data: $updateCollectionDraftData) {
      ...DraftFields
    }
  }
  ${DraftFieldsFragmentDoc}
`;
export type UpdateCollectionDraftMutationFn = Apollo.MutationFunction<
  UpdateCollectionDraftMutation,
  UpdateCollectionDraftMutationVariables
>;

/**
 * __useUpdateCollectionDraftMutation__
 *
 * To run a mutation, you first call `useUpdateCollectionDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCollectionDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCollectionDraftMutation, { data, loading, error }] = useUpdateCollectionDraftMutation({
 *   variables: {
 *      draftId: // value for 'draftId'
 *      updateCollectionDraftData: // value for 'updateCollectionDraftData'
 *   },
 * });
 */
export function useUpdateCollectionDraftMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateCollectionDraftMutation,
    UpdateCollectionDraftMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateCollectionDraftMutation,
    UpdateCollectionDraftMutationVariables
  >(UpdateCollectionDraftDocument, options);
}
export type UpdateCollectionDraftMutationHookResult = ReturnType<
  typeof useUpdateCollectionDraftMutation
>;
export type UpdateCollectionDraftMutationResult =
  Apollo.MutationResult<UpdateCollectionDraftMutation>;
export type UpdateCollectionDraftMutationOptions = Apollo.BaseMutationOptions<
  UpdateCollectionDraftMutation,
  UpdateCollectionDraftMutationVariables
>;
export const RefreshCollectionDraftDocument = gql`
  mutation RefreshCollectionDraft($draftId: String!) {
    refreshCollectionDraft(draftId: $draftId) {
      ...DraftFields
    }
  }
  ${DraftFieldsFragmentDoc}
`;
export type RefreshCollectionDraftMutationFn = Apollo.MutationFunction<
  RefreshCollectionDraftMutation,
  RefreshCollectionDraftMutationVariables
>;

/**
 * __useRefreshCollectionDraftMutation__
 *
 * To run a mutation, you first call `useRefreshCollectionDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshCollectionDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshCollectionDraftMutation, { data, loading, error }] = useRefreshCollectionDraftMutation({
 *   variables: {
 *      draftId: // value for 'draftId'
 *   },
 * });
 */
export function useRefreshCollectionDraftMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RefreshCollectionDraftMutation,
    RefreshCollectionDraftMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RefreshCollectionDraftMutation,
    RefreshCollectionDraftMutationVariables
  >(RefreshCollectionDraftDocument, options);
}
export type RefreshCollectionDraftMutationHookResult = ReturnType<
  typeof useRefreshCollectionDraftMutation
>;
export type RefreshCollectionDraftMutationResult =
  Apollo.MutationResult<RefreshCollectionDraftMutation>;
export type RefreshCollectionDraftMutationOptions = Apollo.BaseMutationOptions<
  RefreshCollectionDraftMutation,
  RefreshCollectionDraftMutationVariables
>;
export const IsSeriesUnzipDoneDocument = gql`
  query IsSeriesUnzipDone($seriesZipFolderName: String!) {
    isSeriesUnzipDone(seriesZipFolderName: $seriesZipFolderName) {
      finishedUnzipping
    }
  }
`;

/**
 * __useIsSeriesUnzipDoneQuery__
 *
 * To run a query within a React component, call `useIsSeriesUnzipDoneQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsSeriesUnzipDoneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsSeriesUnzipDoneQuery({
 *   variables: {
 *      seriesZipFolderName: // value for 'seriesZipFolderName'
 *   },
 * });
 */
export function useIsSeriesUnzipDoneQuery(
  baseOptions: Apollo.QueryHookOptions<
    IsSeriesUnzipDoneQuery,
    IsSeriesUnzipDoneQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    IsSeriesUnzipDoneQuery,
    IsSeriesUnzipDoneQueryVariables
  >(IsSeriesUnzipDoneDocument, options);
}
export function useIsSeriesUnzipDoneLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IsSeriesUnzipDoneQuery,
    IsSeriesUnzipDoneQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    IsSeriesUnzipDoneQuery,
    IsSeriesUnzipDoneQueryVariables
  >(IsSeriesUnzipDoneDocument, options);
}
export type IsSeriesUnzipDoneQueryHookResult = ReturnType<
  typeof useIsSeriesUnzipDoneQuery
>;
export type IsSeriesUnzipDoneLazyQueryHookResult = ReturnType<
  typeof useIsSeriesUnzipDoneLazyQuery
>;
export type IsSeriesUnzipDoneQueryResult = Apollo.QueryResult<
  IsSeriesUnzipDoneQuery,
  IsSeriesUnzipDoneQueryVariables
>;
export const DeployDraftDocument = gql`
  mutation DeployDraft($draftId: String!) {
    deployCollection(draftId: $draftId) {
      ...DraftFields
    }
  }
  ${DraftFieldsFragmentDoc}
`;
export type DeployDraftMutationFn = Apollo.MutationFunction<
  DeployDraftMutation,
  DeployDraftMutationVariables
>;

/**
 * __useDeployDraftMutation__
 *
 * To run a mutation, you first call `useDeployDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeployDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deployDraftMutation, { data, loading, error }] = useDeployDraftMutation({
 *   variables: {
 *      draftId: // value for 'draftId'
 *   },
 * });
 */
export function useDeployDraftMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeployDraftMutation,
    DeployDraftMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeployDraftMutation, DeployDraftMutationVariables>(
    DeployDraftDocument,
    options
  );
}
export type DeployDraftMutationHookResult = ReturnType<
  typeof useDeployDraftMutation
>;
export type DeployDraftMutationResult =
  Apollo.MutationResult<DeployDraftMutation>;
export type DeployDraftMutationOptions = Apollo.BaseMutationOptions<
  DeployDraftMutation,
  DeployDraftMutationVariables
>;
export const CollectionDraftDocument = gql`
  query CollectionDraft($collectionDraftId: String!, $first: Float) {
    collectionDraft(id: $collectionDraftId) {
      ...DraftFields
      seriesTokens(first: $first) {
        edges {
          imageUrl
          tokenId
          name
          attributes {
            name
            value
          }
        }
        pageInfo {
          totalCount
        }
      }
    }
  }
  ${DraftFieldsFragmentDoc}
`;

/**
 * __useCollectionDraftQuery__
 *
 * To run a query within a React component, call `useCollectionDraftQuery` and pass it any options that fit your needs.
 * When your component renders, `useCollectionDraftQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCollectionDraftQuery({
 *   variables: {
 *      collectionDraftId: // value for 'collectionDraftId'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useCollectionDraftQuery(
  baseOptions: Apollo.QueryHookOptions<
    CollectionDraftQuery,
    CollectionDraftQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CollectionDraftQuery, CollectionDraftQueryVariables>(
    CollectionDraftDocument,
    options
  );
}
export function useCollectionDraftLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CollectionDraftQuery,
    CollectionDraftQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CollectionDraftQuery,
    CollectionDraftQueryVariables
  >(CollectionDraftDocument, options);
}
export type CollectionDraftQueryHookResult = ReturnType<
  typeof useCollectionDraftQuery
>;
export type CollectionDraftLazyQueryHookResult = ReturnType<
  typeof useCollectionDraftLazyQuery
>;
export type CollectionDraftQueryResult = Apollo.QueryResult<
  CollectionDraftQuery,
  CollectionDraftQueryVariables
>;
export const DeployCollectionParamsDocument = gql`
  query DeployCollectionParams($draftId: String!) {
    deployCollectionParams(draftId: $draftId) {
      collection {
        ...CollectionFields
      }
      transactionArgs {
        address
        args
        bytecode
        chainId
        method
        value
        gasLimit
      }
      contract {
        ...ContractFields
      }
    }
  }
  ${CollectionFieldsFragmentDoc}
  ${ContractFieldsFragmentDoc}
`;

/**
 * __useDeployCollectionParamsQuery__
 *
 * To run a query within a React component, call `useDeployCollectionParamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeployCollectionParamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeployCollectionParamsQuery({
 *   variables: {
 *      draftId: // value for 'draftId'
 *   },
 * });
 */
export function useDeployCollectionParamsQuery(
  baseOptions: Apollo.QueryHookOptions<
    DeployCollectionParamsQuery,
    DeployCollectionParamsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    DeployCollectionParamsQuery,
    DeployCollectionParamsQueryVariables
  >(DeployCollectionParamsDocument, options);
}
export function useDeployCollectionParamsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    DeployCollectionParamsQuery,
    DeployCollectionParamsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    DeployCollectionParamsQuery,
    DeployCollectionParamsQueryVariables
  >(DeployCollectionParamsDocument, options);
}
export type DeployCollectionParamsQueryHookResult = ReturnType<
  typeof useDeployCollectionParamsQuery
>;
export type DeployCollectionParamsLazyQueryHookResult = ReturnType<
  typeof useDeployCollectionParamsLazyQuery
>;
export type DeployCollectionParamsQueryResult = Apollo.QueryResult<
  DeployCollectionParamsQuery,
  DeployCollectionParamsQueryVariables
>;
